<template>
    <div class="main-feed mt-5">
      <div>
        <v-row class="ma-0">
          <h2>Pending Kennel Name Usage For Individual Dog Registration Signatures</h2>
        </v-row>
      </div>
      <v-data-table 
        :loading="loading"
        :headers="headers"
        :options.sync="options"
        :items="paginatedResponse.data"
        :server-items-length="paginatedResponse.totalCount"
        :search="search"
        :footer-props="footerProps">
          <template v-slot:item.signatureId="{ item }">
            <router-link :to="`/signature/DogRegistrationIndividualKennelNameUsage/${item.signatureId}`" target="_blank">{{
              item.signatureId
            }}</router-link>
          </template>
          <template v-slot:item.submittedAt="{ item }">
            <localized-date-time :instant="item.submittedAt" />
          </template>
          <template v-slot:item.birthDate="{ item }">
            <localized-date :date="item.birthDate" />
          </template>
      </v-data-table>
    </div>
  </template>
  
  <script lang="ts">
  import Vue from "vue";
  import { UserInfo } from "@/types/User";
  import { PaginationOptions, PaginatedResponse } from "@/types/Pagination";
  import workflowService from '@/services/portal/workflowService';
  
  export default Vue.extend({
    name: "DogRegistrationIndividualKennelNameUsageSignatures",
    props: {
      readyToApproveOnly: String,
    },
    data: function () {
      return {
        loading: false,
        paginatedResponse: {} as PaginatedResponse<object>,
        menu: false,
        search: '',
        options: {} as PaginationOptions,
        headers: [
          { text: "#ID", align: "left", value: "signatureId" },
          { text: "Submitted at", align: "left", value: "submittedAt" },
          { text: "Official Name", align: "left", value: "officialName", sortable: false },
          { text: "Date of Birth", align: "left", value: "birthDate", sortable: false },
        ],
        footerProps: { 'items-per-page-options': [10, 20, 30, 40, 50] }
      };
    },
    watch: {
      options: {
        handler() {
          this.loadList();
        },
        deep: true,
      }
    },
    methods: {
      applyFilters: function () {
        this.menu = false;
        this.loadList();
      },
      loadList: async function () {
        this.loading = true;
        const {
          page,
          itemsPerPage,
        } = this.options;
  
        const response = await workflowService.getDogRegistrationIndividualKennelNameUsageSignatureRequests({
          ...this.options,
          page: (page ?? 1) - 1,
          itemsPerPage: itemsPerPage ?? 10
        });
  
        this.loading = false;
        this.paginatedResponse = response;
      }
    },
    computed: {
      userInfo(): UserInfo {
        return this.$store.state.userInfo;
      },
    },
  });
</script>
